import React, { useEffect, useState } from 'react';

const Non_VerifiedSupplements = () => {
  const [animatedCards, setAnimatedCards] = useState([]);

  useEffect(() => {
    // Trigger animation on mount
    const timer = setTimeout(() => {
      setAnimatedCards([0, 1, 2, 3, 4]);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const risks = [
    {
      icon: '⚠️',
      title: 'Inaccurate nutrition labels',
      description: 'Misleading labels that sabotage your fitness progress and health goals',
      color: '#4A90E2',
      bgLight: '#EBF3FB'
    },
    {
      icon: '⚠️',
      title: 'Presence of harmful, banned, or unknown substances',
      description: 'Dangerous chemicals, heavy metals, and prohibited ingredients',
      color: '#5BA3F5',
      bgLight: '#EDF5FF'
    },
    {
      icon: '⚠️',
      title: 'Protein spiking that fakes higher protein content',
      description: 'Protein content inflated with cheap amino acids like glycine & taurine',
      color: '#6BB3F5',
      bgLight: '#F0F7FF'
    },
    {
      icon: '⚠️',
      title: 'Low-grade or contaminated raw materials',
      description: 'Poor quality ingredients that compromise safety and effectiveness',
      color: '#4A90E2',
      bgLight: '#EBF3FB'
    },
    {
      icon: '⚠️',
      title: 'High chances of duplicate or fake market products',
      description: 'Counterfeit supplements with zero quality control',
      color: '#5BA3F5',
      bgLight: '#EDF5FF'
    }
  ];

  return (
    <>
      <style>
        {`
          @keyframes cardSlideIn {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes badgePulse {
            0%, 100% {
              transform: scale(1);
              box-shadow: 0 4px 15px rgba(74, 144, 226, 0.3);
            }
            50% {
              transform: scale(1.05);
              box-shadow: 0 6px 25px rgba(74, 144, 226, 0.5);
            }
          }

          .risk-card-animate {
            animation: cardSlideIn 0.5s ease forwards;
            opacity: 0;
          }

          .warning-badge-animate {
            animation: badgePulse 2s infinite;
          }

          .risk-card-hover:hover {
            transform: translateY(-5px);
            transition: all 0.3s ease;
          }

          @media (max-width: 768px) {
            .risk-grid-responsive {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>

      <section
        data-aos="fade-up"
        style={{
          padding: '80px 20px',
          backgroundColor: '#f0f7ff',
          color: '#333',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Light Blue Background Decorations */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          background: 'radial-gradient(circle, #4A90E210 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute',
          bottom: '-50px',
          left: '-50px',
          width: '250px',
          height: '250px',
          background: 'radial-gradient(circle, #5BA3F510 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute',
          top: '40%',
          right: '10%',
          width: '150px',
          height: '150px',
          background: 'radial-gradient(circle, #6BB3F510 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none',
        }} />

        

        <h2 style={{
          fontSize: 'clamp(28px, 5vw, 38px)',
          fontWeight: 700,
          color: '#1a1a2e',
          marginBottom: '12px',
          background: 'linear-gradient(135deg, #1a1a2e, #4A90E2)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          display: 'inline-block',
        }}>
          The Risks of Using Non-Verified Supplements
        </h2>

        <p style={{
          color: '#666',
          marginTop: '10px',
          fontSize: '16px',
          maxWidth: '600px',
          marginInline: 'auto',
        }}>
          We warn you against these common dangers.
        </p>

        {/* Colorful Grid */}
        <div
          className="risk-grid-responsive"
          style={{
            display: 'grid',
            gap: '20px',
            marginTop: '50px',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            maxWidth: '1100px',
            marginInline: 'auto',
          }}
        >
          {risks.map((risk, index) => (
            <div
              key={index}
              data-aos="fade-up"
              className="risk-card-hover"
              style={{
                backgroundColor: risk.bgLight,
                padding: '24px',
                borderRadius: '16px',
                fontSize: '16px',
                color: '#333',
                border: `2px solid ${risk.color}40`,
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                textAlign: 'left',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              {/* Light Blue Left Border */}
              <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '4px',
                background: `linear-gradient(180deg, ${risk.color}, ${risk.color}80)`,
              }} />

              {/* Icon and Content */}
              <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
                <div style={{
                  fontSize: '28px',
                  background: `${risk.color}20`,
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '12px',
                  flexShrink: 0,
                }}>
                  {risk.icon}
                </div>
                <div>
                  <h3 style={{
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#1a1a2e',
                    marginBottom: '8px',
                    lineHeight: '1.3',
                  }}>
                    {risk.title}
                  </h3>
                  <p style={{
                    fontSize: '14px',
                    color: '#666',
                    lineHeight: '1.5',
                    margin: 0,
                  }}>
                    {risk.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div style={{
          marginTop: '50px',
          padding: '30px',
          background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
          borderRadius: '16px',
          maxWidth: '900px',
          marginInline: 'auto',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute',
            top: '-50%',
            right: '-10%',
            width: '200px',
            height: '200px',
            background: 'radial-gradient(circle, #4A90E230 0%, transparent 70%)',
            borderRadius: '50%',
          }} />
          
          <div style={{ position: 'relative', zIndex: 2 }}>
            <h3 style={{
              fontSize: 'clamp(20px, 4vw, 26px)',
              fontWeight: '700',
              color: 'white',
              marginBottom: '12px',
            }}>
              🛡️ Don't Compromise on Quality
            </h3>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255,255,255,0.8)',
              marginBottom: '20px',
            }}>
              Choose verified, lab-tested supplements for guaranteed purity and safety
            </p>
            <button
              onClick={() => window.location.href = '/shop'}
              style={{
                background: 'linear-gradient(135deg, #4A90E2, #5BA3F5)',
                color: 'white',
                border: 'none',
                padding: '12px 32px',
                fontSize: '15px',
                fontWeight: '600',
                borderRadius: '50px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(74, 144, 226, 0.4)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(74, 144, 226, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(74, 144, 226, 0.4)';
              }}
            >
              Shop Verified Products →
            </button>
          </div>
        </div>

        {/* Trust Badges */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '30px',
          marginTop: '40px',
          flexWrap: 'wrap',
        }}>
          {[
            { icon: '🔬', text: 'Lab Tested' },
            { icon: '✓', text: '100% Authentic' },
            { icon: '⭐', text: 'Trusted by Thousands' },
          ].map((item, idx) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#555',
              fontSize: '13px',
              background: '#fff',
              padding: '6px 16px',
              borderRadius: '50px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
              border: '1px solid #4A90E220',
            }}>
              <span style={{ fontSize: '16px' }}>{item.icon}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Non_VerifiedSupplements;